import { Component, OnInit, Output, EventEmitter, Inject, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { environment } from '../../../environments/environment';

import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/account/user.model';
import { RSAHelperService } from 'src/app/services/rsahelper.service';
import { TokenService } from 'src/app/services/token.service';
import { IdentifiantService } from 'src/app/services/identifiant.service';
import { FcmNotificationService } from 'src/app/services/fcm-notification.service';
import { UpdatepictureComponent } from 'src/app/account/auth/updatepicture/updatepicture.component';
import { MatDialog } from '@angular/material/dialog';
import { HistoriqueService } from 'src/app/services/historique.service';


@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit, OnDestroy {

  element;
  configData;
  cookieValue;
  flagvalue: any;
  countryName: any;
  valueset;
  user: User;
  user1: User;
  ActualUser: string = "";
  name: string;
  image: string;
  picturee: any;
  imagePreview: string | ArrayBuffer;
  logo: any;
  results: any;
  notifications: Array<{
    id?: string | number;
    backendId?: string | number;
    title: string;
    message: string;
    time?: string;
    createdAt?: number;
    icon?: string;
    avatar?: string;
    link?: string;
    read?: boolean;
  }> = [];
  notificationPageSize = 5;
  notificationDisplayLimit = 5;
  private timeRefreshId: any;
  private notificationsSub: any;
  private messageSub: any;
  constructor(@Inject(DOCUMENT) private document: any,
    private router: Router,
    private tokenService: TokenService,
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    public languageService: LanguageService,
    public translate: TranslateService,
    private rsaService: RSAHelperService,
    public _cookiesService: CookieService,
    public dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private historiqueService: HistoriqueService,
    private fcmService: FcmNotificationService

  ) {





  }


  get visibleNotifications() {
    return [...this.notifications]
      .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
      .slice(0, this.notificationDisplayLimit);
  }

  get unreadCount() {
    return this.notifications.filter(notif => !notif.read).length;
  }

  loadMoreNotifications(): void {
    this.notificationDisplayLimit = Math.min(
      this.notificationDisplayLimit + this.notificationPageSize,
      this.notifications.length
    );
  }

  onNotificationsOpen(opened: boolean): void {
    if (!opened) {
      this.markAllAsRead();
    }
  }

  private markAllAsRead(): void {
  const idsToMark = this.notifications
    .filter(notif => !notif.read && notif.backendId !== undefined && notif.backendId !== null)
    .map(notif => notif.backendId as string | number);

  if (idsToMark.length === 0) return;

  // Optimistically mark as read locally
  this.notifications = this.notifications.map(notif => ({
    ...notif,
    read: true
  }));

  // Call backend
  this.fcmService.markNotificationsRead(idsToMark);

  // IMPORTANT: Refresh the full list from server after a short delay
  setTimeout(() => {
    this.fcmService.loadNotifications();   // This will replace the list with fresh data from backend
  }, 800); // give backend time to process
}

  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    console.log("🚀 ~ TopbarComponent ~ ngOnInit ~ ngOnInit")
    this.user = JSON.parse(localStorage.getItem('subscriber'))
    this.name = this.rsaService.decryptWithPrivateKey(this.user['param3'] ?? '') + ' ' + this.rsaService.decryptWithPrivateKey(this.user['param4'] ?? '');

    this.ActualUser = localStorage.getItem('role');
    this.image = localStorage.getItem('picture')
    //console.log("onititimage",this.image);

    this.openMobileMenu = false;
    this.element = document.documentElement;

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3
    };

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
    this.openMobileMenu = false;
    this.element = document.documentElement;
    this.notificationDisplayLimit = this.notificationPageSize;

    // === PREVENT MULTIPLE SUBSCRIPTIONS ===
    this.notificationsSub = this.fcmService.notifications$.subscribe((items) => {
      // Defensive: remove any duplicates by backendId
      const uniqueItems = this.removeDuplicates(items || []);
      this.notifications = uniqueItems;
      console.log("Final notifications array length:", this.notifications.length);
      this.notificationDisplayLimit = Math.min(this.notificationPageSize, uniqueItems.length);
      this.changeDetectorRef.detectChanges();
    });

    this.fcmService.loadNotifications();

    this.fcmService.requestPermission();
    this.fcmService.listen();
    
    // Debug FCM status
    setTimeout(() => {
      this.fcmService.debugFcmStatus();
    }, 2000);

    // === SAME FOR MESSAGE SUB ===
    if (!this.messageSub) {
      this.messageSub = this.fcmService.message$.subscribe(payload => {
        if (!payload) return;

        console.log("🚀 ~ TopbarComponent ~ message$ received:", payload);

        const notification = this.mapFcmPayload(payload);
        if (notification) {
          console.log("🚀 ~ Mapped notification:", notification);
          this.fcmService.prependNotification(notification);

          // Force UI update immediately
          this.changeDetectorRef.detectChanges();
        }
      });
    }

    this.timeRefreshId = setInterval(() => this.changeDetectorRef.detectChanges(), 60000);

  }
  private removeDuplicates(items: any[]): any[] {
    const seen = new Set<string | number>();
    return items.filter(item => {
      const id = item.backendId ?? item.id;
      if (!id) return true; // keep if no id
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }
  ngOnDestroy(): void {
    console.log("🚀 ~ TopbarComponent ~ ngOnDestroy ~ ngOnDestroy");

    if (this.timeRefreshId) {
      clearInterval(this.timeRefreshId);
    }
    console.log("🚀 ~ TopbarComponent ~ ngOnDestroy ~ this.notificationsSub:", this.notificationsSub)
    if (this.notificationsSub) {
      this.notificationsSub.unsubscribe();
      this.notificationsSub = null;        // ← Important
    }
    console.log("🚀 ~ TopbarComponent ~ ngOnDestroy ~ this.messageSub:", this.messageSub)
    if (this.messageSub) {
      this.messageSub.unsubscribe();
      this.messageSub = null;              // ← Important
    }

    this.notifications = [];
  }

  /**
   * Language set
   * @param text 
   * @param lang 
   * @param flag 
   */

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }


  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }


  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
  logout() {
    this.fcmService.reset();
    const fcmToken = localStorage.getItem('fcmToken'); // or however you store it
    if (fcmToken) {
      this.fcmService.unregisterToken(fcmToken).subscribe({
        complete: () => this.tokenService.clear(),
        error: () => this.tokenService.clear() // clear anyway even if it fails
      });
    } else {
      this.tokenService.clear();
    }
  }



  updatePicture(): void {

    //

    var request = JSON.parse(localStorage.getItem('subscriber'))
    var typeUser = localStorage.getItem('role')

    var picture = localStorage.getItem('picture')
    const dialogRef = this.dialog.open(UpdatepictureComponent, {
      data: { identifiant: request['identifiant'], etablissementCode: '00606', canalCode: '03', typeUser: typeUser, picture: picture },
      width: 'auto',
      minWidth: '600px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //console.log('najlaaaa',result);
        this.image = result;
        // var model = {          // param5: this.image,        // }        // localStorage.setItem('subscriber', JSON.stringify(model));
        localStorage.setItem('picture', this.image)
      }

    });
  }

  private mapFcmPayload(payload: any) {
    console.log("🚀 ~ TopbarComponent ~ mapFcmPayload ~ payload:", payload);

    const title = payload?.notification?.title ?? payload?.data?.title;
    const messageBody = payload?.notification?.body ?? payload?.data?.body ?? payload?.data?.message;

    if (!title && !messageBody) {
      console.log("No title or message in payload");
      return null;
    }

    const backendId = payload?.data?.notificationId ?? payload?.data?.id;

    console.log("🚀 ~ backendId from payload:", backendId);

    return {
      id: backendId ?? `fcm-${Date.now()}`,
      backendId: backendId,                    // Important: keep it even if null for now
      title: title || 'Notification',
      message: messageBody || '',
      createdAt: Date.now(),
      icon: 'uil-bell',
      read: false,
      link: payload?.data?.link || 'javascript:void(0);'
    };
  }


  getNotificationTime(notif: { createdAt?: number; time?: string }) {
    if (notif.createdAt) {
      return this.formatRelativeTime(notif.createdAt);
    }
    return notif.time || "a l'instant";
  }

  private formatRelativeTime(timestamp: number): string {
    const diffMs = Date.now() - timestamp;
    const diffMinutes = Math.floor(diffMs / 60000);
    if (diffMinutes <= 0) {
      return "a l'instant";
    }
    if (diffMinutes < 60) {
      return `il y a ${diffMinutes} min`;
    }
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) {
      return `il y a ${diffHours} h`;
    }
    const diffDays = Math.floor(diffHours / 24);
    return `il y a ${diffDays} j`;
  }

}



































